import React, { FC, memo, useState } from 'react';

import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import i18n from '@/content';

import styles from './TagsList.module.scss';

interface TagsListProps {
    tagsList: string[];
    onDelete: (value: string) => void;
    groupsMap?: Map<string, string>;
    readOnly?: boolean;
}

const MAX_VISIBLE_ITEMS = 5;

const TagsList: FC<TagsListProps> = ({ tagsList, onDelete, groupsMap, readOnly = false }) => {
    const [showAll, setShowAll] = useState<boolean>(false);

    const hasMoreItems = tagsList.length > MAX_VISIBLE_ITEMS;
    const visibleItems = showAll || !hasMoreItems
        ? tagsList
        : tagsList.slice(0, MAX_VISIBLE_ITEMS);

    return (
        <div className={styles['tags-list']}>
            {visibleItems.map((value) => (
                <div key={value} className={styles.listItem}>
                    <span className={styles.itemText}>{groupsMap?.get(value) ?? value}</span>
                    {!readOnly && (
                        <button
                            type="button"
                            className={styles.removeButton}
                            onClick={() => onDelete(value)}
                            aria-label={`Remove ${value}`}
                        >
                            <CloseOutlined />
                        </button>
                    )}
                </div>
            ))}
            {hasMoreItems && (
                <Button
                    type="link"
                    className={styles.showAllButton}
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll
                        ? i18n.t('policyEditor.tagsInput.showLess')
                        : i18n.t('policyEditor.tagsInput.showAll', {
                            count: tagsList.length - MAX_VISIBLE_ITEMS,
                        })}
                </Button>
            )}
        </div>
    );
};

export default memo(TagsList);
